import { React, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";

import { Header, LoadingSpinner } from "../../Shared";
import { SubjectAccordion } from "./";
import { ComparisonNames, FilterComparisonMain, FilterNames, CheckAppliedFilter } from "../"
import { Common } from "../../../helper";

import "../../../assets/stlyes/BigPicture/EOYP.scss";

const EoYPredictions = () => {
  const [comparisonGroup, setComparisonGroup] = useState();
  const [subjects, setSubjects] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [generateReport, setGenerateReport] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [selectedComparision, setSelectedComparision] = useState();
  const [selectedClassName, setSelectedClassName_] = useState();
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  let pupilProgress = useSelector((state) => state.pupilProgress.pupilFilter.info)
  const compSelected = useSelector((state) => state.pupilProgress.BPComparisonSelect)
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed);

  const getProgress = (progress) => {
    setSubjects(progress)
    setGenerateReport(true)
    setIsLoading(false)
  }

  const setSelectedClassName = (e) => {
    setSelectedClassName_(e)
  }

  useEffect(() => {
    setComparisonGroup(Common.AllGroups);
  }, [])

  useEffect(() => {
    CheckAppliedFilter(setSelectedComparision, compSelected, setSelectedFilter, selectedClassName, pupilProgress);
  }, [subjects])

  return (
    <div className="bigPictureEOYP">
      <div className="Page-layout">
        <div className="Page-header">
          <Header />
          <div className="Page-body" style={{ paddingRight: !isNavCollapsed ? "250px" : "75px" }} >
            <div className="EOYP-header">
              <div className="Page-name">
                <span className="EOYP-name-firstText">{Common.BigPicturePageName}</span>
                <span className="EOYP-name-secondText">{Common.EndOfYearPredictions}</span>
              </div>
              <div className="EOYP-title">
                <span className="EOYP-titleText">{Common.EndOfYearPredictions}</span>
              </div>
              <div className="EOYP-subtitle">
                <span className="EOYP-subtitleText">{Common.EndOfYearPredictionsSubtext}</span>
              </div>
            </div>
            <div className="EOYP-comparison">
              <FilterComparisonMain setSubjects={getProgress} number={1} setIsLoading={setIsLoading} isGLD={true} setSelectedClassName={setSelectedClassName} selectedBaseLine={""} isSubject={true} />
            </div>
            <div>
              {
                isLoading ? <LoadingSpinner /> : (generateReport ? (<Row style={{ marginTop: "20px" }}>
                  <Col sm={12}>
                    <div className="bigPictureDataView-EOYP">
                      <Row>
                        <Col sm={9}>

                          <div className="title">
                            <span className="dataView-title">{`${Common.EndOfYearPredictions}: `}</span>
                            <span className="dataView-title">{comparisonGroup}</span>
                          </div>
                          <div className="subtitles1">
                            <span className="dataView-subtitle">{`${Common.Comparison}: `}</span>
                            <span className="dataView-subtitle2">{ComparisonNames(selectedComparision)}</span>
                          </div>
                          <div className="subtitles2">
                            <span className="dataView-subtitle">{`${Common.AppliedFilters}: `}</span>
                            <span className="dataView-subtitle2">{selectedFilter && FilterNames(selectedFilter)}</span>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          {subjects && subjects.map((sub, i) => (<SubjectAccordion subject={sub} key={i} index={i} openAccordionIndex={openAccordionIndex} setOpenAccordionIndex={setOpenAccordionIndex} />))}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>) : "")
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { EoYPredictions }